<script setup>
import { ref } from 'vue';
import { useInfiniteScroll } from '@/composables/use-infinite-scroll';
import SportLiveTvEmpty from '@/sport-live-tv/components/sport-live-tv-empty.vue';
import SportLiveTvError from '@/sport-live-tv/components/sport-live-tv-error.vue';
import SportLiveTvEventCard from '@/sport-live-tv/components/sport-live-tv-event-card.vue';
import SportLiveTvEventGrid from '@/sport-live-tv/components/sport-live-tv-event-grid.vue';
import SportLiveTvLoading from '@/sport-live-tv/components/sport-live-tv-loading.vue';

const props = defineProps({
  events: { type: Array, required: true },
  isLoading: { type: Boolean, default: false },
  isError: { type: Boolean, default: false },
  hasNextPage: { type: Boolean, default: false },
  isFetchingNextPage: { type: Boolean, default: false },
  scoresVisible: { type: Boolean, default: false },
});

const emit = defineEmits(['select', 'clear-filters', 'fetch-next-page', 'retry']);

const loadingAnchor = ref(null);

useInfiniteScroll(loadingAnchor, {
  hasNextPage: () => props.hasNextPage,
  isFetchingNextPage: () => props.isFetchingNextPage,
  fetchNextPage: () => emit('fetch-next-page'),
});
</script>

<template>
  <SportLiveTvLoading v-if="isLoading" />
  <SportLiveTvError v-else-if="isError && !events.length" @retry="emit('retry')" />
  <SportLiveTvEmpty v-else-if="!events.length" clearable @clear-filters="emit('clear-filters')" />
  <div v-else>
    <SportLiveTvEventGrid>
      <SportLiveTvEventCard v-for="event in events" :key="event.id" :event="event" :scores-visible="scoresVisible" @select="emit('select', $event)" />
    </SportLiveTvEventGrid>
    <div ref="loadingAnchor" class="sport-live-tv-results__anchor" />
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-results__anchor {
  height: 1px;
}
</style>
